var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./VueDisqus.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4eac2a7c\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../vue-loader/lib/selector?type=template&index=0!./VueDisqus.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-disqus/VueDisqus.vue
// module id = 383
// module chunks = 1